'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var dagCBOR = require('@ipld/dag-cbor');

var raw = require('multiformats/codecs/raw');

var cid = require('multiformats/cid');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var dagCBOR__namespace = /*#__PURE__*/_interopNamespace(dagCBOR);

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

function findLinks(node) {
  var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var key in node) {
    var val = node[key];

    if (key === '/' && Object.keys(node).length === 1) {
      try {
        links.push({
          Name: '',
          Tsize: 0,
          Hash: cid.CID.parse(val)
        });
        continue;
      } catch (_) {}
    }

    var cid$1 = cid.CID.asCID(val);

    if (cid$1) {
      links.push({
        Name: '',
        Tsize: 0,
        Hash: cid$1
      });
      continue;
    }

    if (Array.isArray(val)) {
      findLinks(val, links);
    }

    if (val && typeof val === 'object') {
      findLinks(val, links);
    }
  }

  return links;
}

function createLinks(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs;

  function links(_x) {
    return _links.apply(this, arguments);
  }

  function _links() {
    _links = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      var options,
          codec,
          block,
          node,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return codecs.getCodec(cid.code);

            case 3:
              codec = _context.sent;
              _context.next = 6;
              return repo.blocks.get(cid, options);

            case 6:
              block = _context.sent;
              node = codec.decode(block);

              if (!(cid.code === raw__namespace.code)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", []);

            case 10:
              if (!(cid.code === dagPB__namespace.code)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", node.Links);

            case 12:
              if (!(cid.code === dagCBOR__namespace.code)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", findLinks(node));

            case 14:
              throw new Error("Cannot resolve links from codec ".concat(cid.code));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _links.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(links);
}

exports.createLinks = createLinks;